export default { 
  Close: {
    TitlePopup: 'Khóa sổ kỳ kế toán',
    TextAlert: 'Sau khi khóa sổ, không thể sửa các chứng từ được hạch toán từ ngày khóa sổ trở về trước',
    OldDate: 'Ngày khóa sổ cũ',
    NewDate: 'Ngày khóa sổ mới',
    Sucess: 'Khóa sổ thành công',
  },
  Reopen: {
    TitlePopup: 'Bỏ khóa sổ',
    TextAlert: `Ngày khóa sổ cũ là OLDDATE, để sửa lại các chứng từ hạch toán trước ngày OLDDATE, bạn cần thực hiện bỏ khóa sổ. Bạn muốn sửa chứng từ hạch toán từ ngày nào?`,
    NewDate: 'Từ ngày',
    Sucess: 'Bỏ khóa sổ thành công',
  },
  HandleUnpostedVouchers: {
    TitlePopup: 'Xử lý các chứng từ chưa ghi sổ',
    Post: 'Ghi sổ',
    ChangePostedDate: 'Chuyển ngày hạch toán',
    Delete: 'Xóa',
  }
}